<template>
	<div class="payType">
		<div class="tit">
			{{i18n('302')}}
		</div>
		<div class="sm">
			{{i18n('308')}}
		</div>
		<div class="list">
			<div :class="pay_method==2?'item itemAc':'item'" @click="pay_methodChange(2)">
				<div class="top">
					<img src="@/assets/zfb.png" alt="" class="zfb" style="width: 40px;height: 40px;">
				</div>
				<div class="bot">
					ALIPAY
				</div>
			</div>
			<div :class="pay_method==4?'item itemAc':'item'" @click="pay_methodChange(4)">
				<div class="top">
					<img src="@/assets/grabpay.png" alt="" class="GrabPay" style="width: 95px;height: 26px;">
				</div>
				<div class="bot">
					GrabPay
				</div>
			</div>
			<div class="item" :class="pay_method==3?'item itemAc':'item'" @click="pay_methodChange(3)">
				<div class="top">
					<img src="@/assets/gcash.png" alt="" class="Gcash" style="width: 95px;height: 26px;">
				</div>
				<div class="bot">
					Gcash
				</div>
			</div>
			<div :class="pay_method==5?'item itemAc':'item'" @click="pay_methodChange(5)">
				<div class="top">
					<img src="@/assets/visa.png" alt="" class="Visa" style="width: 95px;height: 26px;">
				</div>
				<div class="bot">
					Visa
				</div>
			</div>
		</div>
		<div class="but" @click="sub">
			{{i18n('38')}}
		</div>
	</div>
</template>

<script>
	export default {
		props:['pay_method'],
		name: "payType",
		data() {
			return {
				
			}
		},
		methods: {
			pay_methodChange(type){
				this.$emit("pay_methodChange",type)
			},
			sub(){
				this.$emit("sub")
			}
		},
		computed: {
			userInfo() {
				return this.$store.state.user.userInfo
			},
		},
		created() {
			
		},
		mounted() {

		}
	};
</script>

<style scoped>
	.but{
		width: 310px;
		height: 44px;
		background: #56AB7B;
		border-radius: 22.5px;
		margin: 0 auto;
		font-family: PingFangSC-Medium;
		font-size: 18px;
		color: #FFFFFF;
		text-align: center;
		font-weight: 500;
		line-height: 44px;
		cursor: pointer;
	}
	.list{
		padding: 0 24px;
		display: flex;
		align-items: center;
	}
	.list .item{
		width: 200px;
		height: 79px;
		background: #FFFFFF;
		border: 1px solid rgba(217,217,217,1);
		border-radius: 6px;
		margin-right: 16px;
		margin-bottom: 26px;
		cursor: pointer;
	}
	.list .itemAc{
		border: 1px solid #56AB7B;
	}
	.list .item .top{
		height: 37px;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		padding-top: 10px;
	}
	.list .item .bot{
		font-family: PingFangSC-Regular;
		font-size: 12px;
		color: #4E5969;
		font-weight: 400;
		text-align: center;
	}
	.sm{
		padding-left: 24px;
		line-height: 52px;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #1D2129;
		font-weight: 400;
	}
	.payType {
		width: 1032px;
		background: #FFFFFF;
		border-radius: 12px;
		position: relative;
		z-index: 10;
		padding-bottom: 24px;
	}

	.payType .tit {
		width: 100%;
		height: 48px;
		border-bottom: 1px solid #56AB7B;
		padding-left: 24px;
		box-sizing: border-box;
		font-family: PingFangSC-Medium;
		font-size: 14px;
		color: #1D2129;
		font-weight: 500;
		line-height: 48px;
	}
</style>
